import { User, UserAccess } from '../../interfaces';
import { IconButton, CircularProgress } from '@mui/material';
import XLSX from 'xlsx';
import ExcelLogo from '../../assets/microsoft-excel.svg?react';

export interface Props {
  users: UserAccess[];
  licenseId: number;
  subscriptionId: number;
  analyticsData?: { id: string; userId: number; guideViewsCount: number }[] | null;
  isLoadingAnalytics?: boolean;
}

export function ExcelExportLicenseUsers({ users, licenseId, subscriptionId, analyticsData, isLoadingAnalytics }: Props) {
  const headings: string[] = ['Id', 'Navn', 'E-post', 'Sist innlogget', 'Sidevisninger'];

  const getGuideViews = (user: User) => {
    if (!analyticsData) return 0;

    const userData = analyticsData.find((x) => x.userId === user.id);
    if (!userData) return 0;

    return userData.guideViewsCount;
  };

  const getSubscription = (subscription: number) => {
    switch (subscription) {
      case 9:
        return 'BFS';
      case 10:
        return 'BFSB';
      case 11:
        return 'BFSP';
      case 12:
        return 'BFSF';
      case 13:
        return 'BFSU';
      case 16:
        return 'BVN';
      case 19:
        return 'Prøve';
      default:
        return 'Ukjent';
    }
  };

  const top: string[] = ['LicenseId', licenseId.toString(), 'SubscriptionId', getSubscription(subscriptionId)];

  const lines: (string | number | null)[][] = users.map((item) => {
    var a: (string | number | null)[] = [];

    a.push(item.user.id);
    a.push(item.user.displayName);
    a.push(item.user.email);
    a.push(item.user.lastLoggedIn !== null ? item.user.lastLoggedIn.toString() : '');
    a.push(getGuideViews(item.user));

    return a;
  });

  lines.unshift(headings);
  lines.unshift(top);

  return (
    <IconButton
      onClick={() => exportFile(lines)}
      title={isLoadingAnalytics ? 'Laster data...' : 'Eksport til Excel'}
      disabled={!users || isLoadingAnalytics}
    >
      {isLoadingAnalytics ? (
        <CircularProgress size={24} />
      ) : (
        <ExcelLogo
          style={{
            width: 24,
            height: 24,
          }}
        />
      )}
    </IconButton>
  );
}

function exportFile(lines: (string | number | null)[][]) {
  const sheet = XLSX.utils.aoa_to_sheet(lines);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Lisensbrukere');
  XLSX.writeFile(workbook, 'lisensbrukere.xlsx');
}